import { AxiosResponse } from "axios";
import { oc } from "ts-optchain";

import { DealernetApi } from "./DealernetApi";
import { ILanterShippingDetailDto, ILanterDeliveryDetailsDto } from "@/types"

export class ShippingDetailService {
    public static async getShippingDetails(params: { accountId: number, userId: number, invoiceId: number, source: string }): Promise<ILanterShippingDetailDto[]> {
        // Rapidparts shipments do not use Lanter
        if (params.source === "Rapidparts"){
            return new Array(0);
        }

        const response = await DealernetApi.client().request({
            method: "get",
            url: 'ShippingDetail/GetShippingDetails',
            params,
        });

        const data = oc(response as AxiosResponse<ILanterShippingDetailDto>).data();

        if (data == undefined) {
            return new Array(0)
        } 

        return data;
    }

    public static async getLanterScanDetails(params: { accountId: number, userId: number, invoiceId: number, source: string }): Promise<ILanterShippingDetailDto[]> {
        // Rapidparts shipments do not use Lanter
        if (params.source === "Rapidparts"){
            return new Array(0);
        }

        const response = await DealernetApi.client().request({
            method: "get",
            url: 'ShippingDetail/GetDeliveryDetails',
            params,
        });

        const data = oc(response as AxiosResponse<ILanterDeliveryDetailsDto>).data();

        if (data == undefined) {
            return new Array(0)
        } 
        return data;
    }
}